export const SuccessNotificationIcon: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.0062 20.232L8.67075 15.8965L7.22559 17.3417L13.0062 23.1223L25.3933 10.7352L23.9482 9.29004L13.0062 20.232Z"
      fill="#12B17A"
    />
    <circle cx="16" cy="16" r="15" stroke="#12B17A" strokeWidth="2" />
  </svg>
);
